import dot from 'dot-prop-immutable';

import { types } from './actions';

const initialState = {
  currentPage: 1,
  filters: {
    assignedToIn: [],
    quoteNumber: '',
    statusIn: [],
  },
  isFetchingTasks: false,
  tasks: [],
  tasksCount: 0,
  teamMembers: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.BUILD_FILTERS_SUCCESS:
      return {
        ...state,
        teamMembers: payload.teamMembers,
      };
    case types.FILTERS_APPLY:
    case types.FILTERS_SET:
      return dot.merge(
        {
          ...state,
          currentPage: payload.page,
        },
        'filters',
        {
          assignedToIn: payload.assignedToIn,
          quoteNumber: payload.quoteNumber,
          statusIn: payload.statusIn,
        },
      );
    case types.FETCH_TASKS_ERROR:
      return {
        ...state,
        isFetchingTasks: false,
      };
    case types.FETCH_TASKS_REQUEST:
      return {
        ...state,
        isFetchingTasks: true,
      };
    case types.FETCH_TASKS_SUCCESS:
      return {
        ...state,
        isFetchingTasks: false,
        tasks: payload.tasks,
        tasksCount: payload.count,
      };
    case types.PAGINATION_SET:
      return {
        ...state,
        currentPage: payload.page,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.tasks.listPage;

export const getFilters = (state) => getScope(state).filters;

export const getCurrentPage = (state) =>
  Number(getScope(state).currentPage || 1);

export const getAssignedToIn = (state) => getFilters(state).assignedToIn;

export const getIsFetchingTasks = (state) => getScope(state).isFetchingTasks;

export const getQuoteNumber = (state) => getFilters(state).quoteNumber;

export const getStatusIn = (state) => getFilters(state).statusIn;

export const getTasks = (state) => getScope(state).tasks;

export const getTasksCount = (state) => getScope(state).tasksCount;

export const getTeamMembers = (state) => getScope(state).teamMembers;

export default reducer;
